import React, { FC } from 'react';
import { Divider } from '@wix/design-system';
import { Route, Routes } from 'react-router-dom';
import './global.scss';
import css from './App.scss';
import { TemplatesMainPageWrapper } from '../MainPage/TemplatesMainPageWrapper';
import { SingleTemplatePageWrapper } from '../TemplatePage/SingleTemplatePageWrapper';
import '@wix/design-system/styles.global.css';
import { MainHeader } from '@wix/dev-center-elements';
import { OpenBlocksTemplate } from '../OpenBlocksTemplate/OpenBlocksTemplate';
import { APP_PAGES } from '../../constants/routes';

const App: FC = () => (
  <>
    <div className={css.wixMainHeader}>
      <MainHeader
        afterLogoutLink={window.location.href}
        afterLoginLink={window.location.href}
        experiments={{ 'specs.dcc.appTemplates': 'true' }}
      />
    </div>
    <div className={css.appWrapper}>
      <Routes>
        <Route
          path={APP_PAGES.TEMPLATES_MAIN_PAGE}
          element={<TemplatesMainPageWrapper />}
        />
        <Route
          path={APP_PAGES.TEMPLATE_PAGE}
          element={<SingleTemplatePageWrapper />}
        />
        <Route
          path={APP_PAGES.OPEN_BLOCKS_TEMPLATE_ROUTE}
          element={<OpenBlocksTemplate />}
        />
      </Routes>
      <div className={css.dividerBeforeFooter}>
        <Divider />
      </div>
    </div>
  </>
);

export default App;
